<div [style]="column.cellStyle">
	<ng-container *ngIf="!column.isImage && column.translate">{{ transformedValue | translate }}</ng-container>
	<ng-container *ngIf="!column.isImage && !column.translate">{{ transformedValue }}</ng-container>
	<ng-container *ngIf="column.isImage">
		<img
			*ngIf="!!transformedValue && transformedValue.length > 0"
			[src]="domSanitizer.bypassSecurityTrustResourceUrl(transformedValue)"
		/>
		<div *ngIf="!transformedValue || transformedValue.length === 0" class="img-cell-placeholder"></div>
	</ng-container>
</div>
